import BaseBlocks from './BaseBlocks';
import * as BlockComponents from './index';

const Blocks = (props) => <BaseBlocks components={BlockComponents} {...props} />;

export default Blocks;
